module.exports = __webpack_public_path__ + "img/west-spring-544x667.bf65445a.jpg";